import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../auxiliares/auxiliares.module';
import { RegistrosRoutingModule } from './registros..routing.module';
import { ListarRegistrosComponent } from './listado-registros/listado-registros.component';

@NgModule({
  declarations: [ListarRegistrosComponent],
  imports: [CommonModule, AuxiliaresModule, RegistrosRoutingModule],
})
// eslint-disable-next-line prettier/prettier
export class RegistrosModule {}
